import { useLocalStorage } from '@festina-life/ui/hooks'

export const searchPageTabLocalStorageKey = 'searchPageTab'

export const useLocalStorageSearchPageTab = () =>
  useLocalStorage<{ name: string }>(searchPageTabLocalStorageKey)
